import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'

import './theme.scss'
import './index.css'
import { BrowserRouter as Router } from 'react-router'
import { TogglesProvider } from 'svv-hradm-unleash-toggles-react'

import App from './components/App'
import ScrollToTop from './components/standardkomponenter/ScrollToTop'
import configureStore from './configureStore'
import { URL_BACKEND } from './middleware/konstanter'
import { SAME_ORIGIN } from './ressurser/Konstanter'

const store = configureStore()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <TogglesProvider
        app={'trine'}
        togglesUrlPath={URL_BACKEND + '/toggles'}
        requestConfig={{
            credentials: SAME_ORIGIN
        }}
    >
        <Provider store={store}>
            <Router>
                <ScrollToTop />
                <App />
            </Router>
        </Provider>
    </TogglesProvider>
)
